import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogOverlay,
  AlertDialogPortal,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

export type BlockDoneDealReason = {
  key: string;
  title: string;
};

export function BlockDoneDealDialog({
  open,
  onOpenChange,
  reasons,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  reasons: BlockDoneDealReason[];
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogPortal>
        <AlertDialogOverlay />
        <AlertDialogContent>
          <AlertDialogTitle className="font-medium">
            This deal cannot be marked as Done yet.
          </AlertDialogTitle>
          <AlertDialogDescription>
            Please complete the following requirements to continue:
          </AlertDialogDescription>
          <ul className="list-disc list-inside">
            {reasons.map((reason) => (
              <li key={reason.key} className="font-small">
                {reason.title}
              </li>
            ))}
          </ul>
          <div className="mt-4 flex justify-end gap-2">
            <AlertDialogCancel variant="mauve">Close</AlertDialogCancel>
          </div>
        </AlertDialogContent>
      </AlertDialogPortal>
    </AlertDialog>
  );
}
